import { render, staticRenderFns } from "./ApplicantProfileAttachments.vue?vue&type=template&id=555d5284"
import script from "./ApplicantProfileAttachments.vue?vue&type=script&lang=js"
export * from "./ApplicantProfileAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports